export default "6d87325607eaf90c.svg"